export default {
  computed: {
    jointBolt() {
      let product = this.products.find(p => p.type === 'jointBolt')
      let variant = product.variants.find(v => v.color == 'Galvad')
      let fullProduct = { ...product, ...variant }
      delete fullProduct.variants;

      let amount = Math.ceil((this.snowProtection.amount - 1) / 2)
        + (this.roofBridge.amount + this.roofBridgeShort.amount - 1) / 2
        + this.roofBridgeConsole.amount;

      if (this.safetySystem == 'PW' && this.elevationMount.artNumber.startsWith('1398')) {
        amount += (this.elevationMount.amount - 1) / 2;
      }

      amount = Math.ceil(amount);

      // Add properties
      fullProduct.singlepack = amount;
      fullProduct.amount = fullProduct.singlepack;
      fullProduct.unit = 'pkt';
      fullProduct.sort = 99

      return fullProduct;
    }
  }
};
